"use client";
import React, { useState } from "react";
import Button from "../../../ui/Button";
import { PropertySearchFormRef } from "../../design2/components/HeroSearch2";
// import { PropertyType } from "../../design1/components/HeroSearchComponent";
import { SearchBar } from "../../design2/components/HomeFilterSearch";
import { useRef } from "react";
import { PropertyType } from "../../design1/components/HeroSearchComponent";
// import { useRouter } from "next/navigation";

const HomeFilterSearch: React.FC<{ variant?: boolean }> = ({ variant }) => {
  const searchFormRef = useRef<PropertySearchFormRef>(null);
  const triggerSearchFromParent = () => {
    if (searchFormRef.current) {
      searchFormRef.current.handleSearch();
    }
  };

  const [openSearchBar, setOpenSearchBar] = useState(false);
  const [activeTab, setActiveTab] = useState<string>("For rent");
  // const tabs: Tabs[] = ["Rent", "Shortlet", "Sale"];
  type Tabs = {
    label: string;
    value: string;
  };
  const tabs: Tabs[] = [
    { label: "Rent", value: "For rent" },
    { label: "Shortlet", value: "For shortlet" },
    { label: "Sale", value: "For sale" },
  ];
  const [searchQuery, setSearchQuery] = useState("");
  return (
    <div
      className={`mt-8 relative  xs:w-full xs:!max-w-[10000px]  max-w-[700px] ${
        variant && "!max-w-[550px]"
      }`}
    >
      <div className="flex mb-[1px] gap-2">
        {tabs.map((tab) => (
          <Tab
            key={tab.label}
            label={tab.label}
            isActive={activeTab === (tab.value as string)}
            onClick={() => setActiveTab(tab.value)}
          />
        ))}
      </div>
      <div
        className={`first flex items-center gap-4 bg-white p-1 rounded-tl-none rounded-xl ${
          variant && "!p-1"
        } relative`}
      >
        <div
          onClick={() => {
            setOpenSearchBar((prev) => !prev);
      
          }}
          style={{
            backgroundColor: "rgba(var(--primary-color-rgb), 0.1)",
          }}
          className={`filter-trigger hidden md:grid place-items-center px-4 py-3 h-full ${
            variant && "md:!hidden"
          } rounded-md cursor-pointer`}
        >
          <FilterIcon />
        </div>
        <div className="search pl-8  flex-1">
          <input
            onChange={(e) => setSearchQuery(e.target.value)}
            className="placeholder:text-label-main/50 w-full py-2 text-label-main focus:outline-none focus:border-none"
            placeholder="Look up by ID or title"
            type="text"
          />
        </div>
        <div className="search-item flex gap-1">
          <div
            onClick={() => {
              setOpenSearchBar((prev) => !prev);
            }}
            style={{
              backgroundColor: "rgba(var(--primary-color-rgb), 0.1)",
            }}
            className={`filter-trigger md:hidden grid place-items-center ${
              variant && "!hidden"
            } px-4 py-3 h-full rounded-r-none rounded-md cursor-pointer`}
          >
            <FilterIcon />
          </div>
          <Button
            onClick={() => {
              if (!openSearchBar) {
                // setOpenSearchBar(true);
                // Delay the search to allow PropertySearchForm to render
                setTimeout(() => {
                  triggerSearchFromParent();
                }, 0);
              } else {
                triggerSearchFromParent();
              }
            }}
            className={`primary-btn rounded-l-none !px-5 py-3 ${
              variant && "!py-4"
            } h-full flex gap-2 items-center`}
          >
            <span className={`md:hidden ${variant && "!hidden"}`}>Search</span>{" "}
            <SearchIcon />
          </Button>
        </div>
      </div>
      <span className="absolute bg-white w-full top-[104%]  bottom-0">
        <SearchBar
          searchQuery={searchQuery}
          searchFormRef={searchFormRef}
          type={activeTab as PropertyType}
          open={openSearchBar}
        />
      </span>
    </div>
  );
};

export default HomeFilterSearch;

const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.7507 1.66699C7.62119 1.66709 6.50809 1.9373 5.50425 2.45507C4.50041 2.97285 3.63494 3.72317 2.98006 4.64345C2.32518 5.56373 1.89987 6.62728 1.73962 7.74536C1.57937 8.86344 1.68882 10.0036 2.05885 11.0708C2.42887 12.138 3.04874 13.1012 3.86673 13.8801C4.68472 14.659 5.67712 15.231 6.76113 15.5483C7.84514 15.8657 8.98932 15.9192 10.0982 15.7044C11.2071 15.4896 12.2486 15.0128 13.1357 14.3137L16.179 17.357C16.3362 17.5088 16.5467 17.5928 16.7652 17.5909C16.9837 17.589 17.1927 17.5013 17.3472 17.3468C17.5017 17.1923 17.5894 16.9833 17.5913 16.7648C17.5932 16.5463 17.5092 16.3358 17.3574 16.1787L14.314 13.1353C15.1374 12.0908 15.65 10.8357 15.7933 9.51343C15.9366 8.1912 15.7047 6.85534 15.1242 5.65874C14.5437 4.46213 13.6381 3.45312 12.511 2.74718C11.3838 2.04125 10.0807 1.6669 8.7507 1.66699ZM3.33403 8.75033C3.33403 7.31374 3.90472 5.93599 4.92054 4.92016C5.93636 3.90434 7.31411 3.33366 8.7507 3.33366C10.1873 3.33366 11.565 3.90434 12.5809 4.92016C13.5967 5.93599 14.1674 7.31374 14.1674 8.75033C14.1674 10.1869 13.5967 11.5647 12.5809 12.5805C11.565 13.5963 10.1873 14.167 8.7507 14.167C7.31411 14.167 5.93636 13.5963 4.92054 12.5805C3.90472 11.5647 3.33403 10.1869 3.33403 8.75033Z"
      fill="white"
    />
  </svg>
);
const FilterIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 5.50245C8.73478 5.50245 8.48043 5.60781 8.29289 5.79534C8.10536 5.98288 8 6.23723 8 6.50245C8 6.76767 8.10536 7.02202 8.29289 7.20956C8.48043 7.39709 8.73478 7.50245 9 7.50245C9.26522 7.50245 9.51957 7.39709 9.70711 7.20956C9.89464 7.02202 10 6.76767 10 6.50245C10 6.23723 9.89464 5.98288 9.70711 5.79534C9.51957 5.60781 9.26522 5.50245 9 5.50245ZM6.17 5.50245C6.3766 4.91692 6.75974 4.40988 7.2666 4.05124C7.77346 3.6926 8.37909 3.5 9 3.5C9.62091 3.5 10.2265 3.6926 10.7334 4.05124C11.2403 4.40988 11.6234 4.91692 11.83 5.50245H19C19.2652 5.50245 19.5196 5.60781 19.7071 5.79534C19.8946 5.98288 20 6.23723 20 6.50245C20 6.76767 19.8946 7.02202 19.7071 7.20956C19.5196 7.39709 19.2652 7.50245 19 7.50245H11.83C11.6234 8.08798 11.2403 8.59502 10.7334 8.95366C10.2265 9.31231 9.62091 9.5049 9 9.5049C8.37909 9.5049 7.77346 9.31231 7.2666 8.95366C6.75974 8.59502 6.3766 8.08798 6.17 7.50245H5C4.73478 7.50245 4.48043 7.39709 4.29289 7.20956C4.10536 7.02202 4 6.76767 4 6.50245C4 6.23723 4.10536 5.98288 4.29289 5.79534C4.48043 5.60781 4.73478 5.50245 5 5.50245H6.17ZM15 11.5025C14.7348 11.5025 14.4804 11.6078 14.2929 11.7953C14.1054 11.9829 14 12.2372 14 12.5025C14 12.7677 14.1054 13.022 14.2929 13.2096C14.4804 13.3971 14.7348 13.5025 15 13.5025C15.2652 13.5025 15.5196 13.3971 15.7071 13.2096C15.8946 13.022 16 12.7677 16 12.5025C16 12.2372 15.8946 11.9829 15.7071 11.7953C15.5196 11.6078 15.2652 11.5025 15 11.5025ZM12.17 11.5025C12.3766 10.9169 12.7597 10.4099 13.2666 10.0512C13.7735 9.6926 14.3791 9.5 15 9.5C15.6209 9.5 16.2265 9.6926 16.7334 10.0512C17.2403 10.4099 17.6234 10.9169 17.83 11.5025H19C19.2652 11.5025 19.5196 11.6078 19.7071 11.7953C19.8946 11.9829 20 12.2372 20 12.5025C20 12.7677 19.8946 13.022 19.7071 13.2096C19.5196 13.3971 19.2652 13.5025 19 13.5025H17.83C17.6234 14.088 17.2403 14.595 16.7334 14.9537C16.2265 15.3123 15.6209 15.5049 15 15.5049C14.3791 15.5049 13.7735 15.3123 13.2666 14.9537C12.7597 14.595 12.3766 14.088 12.17 13.5025H5C4.73478 13.5025 4.48043 13.3971 4.29289 13.2096C4.10536 13.022 4 12.7677 4 12.5025C4 12.2372 4.10536 11.9829 4.29289 11.7953C4.48043 11.6078 4.73478 11.5025 5 11.5025H12.17ZM9 17.5025C8.73478 17.5025 8.48043 17.6078 8.29289 17.7953C8.10536 17.9829 8 18.2372 8 18.5025C8 18.7677 8.10536 19.022 8.29289 19.2096C8.48043 19.3971 8.73478 19.5025 9 19.5025C9.26522 19.5025 9.51957 19.3971 9.70711 19.2096C9.89464 19.022 10 18.7677 10 18.5025C10 18.2372 9.89464 17.9829 9.70711 17.7953C9.51957 17.6078 9.26522 17.5025 9 17.5025ZM6.17 17.5025C6.3766 16.9169 6.75974 16.4099 7.2666 16.0512C7.77346 15.6926 8.37909 15.5 9 15.5C9.62091 15.5 10.2265 15.6926 10.7334 16.0512C11.2403 16.4099 11.6234 16.9169 11.83 17.5025H19C19.2652 17.5025 19.5196 17.6078 19.7071 17.7953C19.8946 17.9829 20 18.2372 20 18.5025C20 18.7677 19.8946 19.022 19.7071 19.2096C19.5196 19.3971 19.2652 19.5025 19 19.5025H11.83C11.6234 20.088 11.2403 20.595 10.7334 20.9537C10.2265 21.3123 9.62091 21.5049 9 21.5049C8.37909 21.5049 7.77346 21.3123 7.2666 20.9537C6.75974 20.595 6.3766 20.088 6.17 19.5025H5C4.73478 19.5025 4.48043 19.3971 4.29289 19.2096C4.10536 19.022 4 18.7677 4 18.5025C4 18.2372 4.10536 17.9829 4.29289 17.7953C4.48043 17.6078 4.73478 17.5025 5 17.5025H6.17Z"
        fill="var(--primary-color)"
      />
    </svg>
  );
};
type TabProps = {
  label: string;
  isActive: boolean;
  onClick: () => void;
};
const Tab = ({ label, isActive, onClick }: TabProps) => {
  return (
    <button
      onClick={onClick}
      className={` py-2 px-5 rounded-t-md w-max text-center font-medium transition-colors duration-300 ${
        isActive ? " bg-themeColor text-white" : "text-secondary-main bg-white"
      }`}
    >
      {label}
    </button>
  );
};
